import { DynamicIconType } from '@allesauto/utils/consts';
import clsx from 'clsx';
import React from 'react';

import DynamicIcon from '../dynamicIcon';

export interface ContentStepProps {
  title: string;
  description: string;
  number?: string;
  icon?: DynamicIconType;
  smallerTopSpace?: boolean;
}

const ContentStep = ({
  title,
  description,
  number,
  icon,
  smallerTopSpace = false,
}: ContentStepProps) => {
  const className = {
    content: clsx('sm:mt-40px lg:mt-80px', smallerTopSpace && 'lg:!mt-0'),
    numberIconContent: clsx(
      'flex font-headline items-center justify-center mb-10px text-headline1 w-fit sm:h-40px sm:mb-0 lg:h-60px',
      'border-green60 text-green80',
      'monochrome:border-white monochrome:text-white'
    ),
    title:
      'mb-10px text-purple80 monochrome:text-white lg:min-h-[65px] text-headline3',
    iconContainer:
      'mb-20px ml-[-2px] sm:h-[50px] sm:w-[50px] md:h-[60px] md:mb-25px md:w-[60px]',
  };

  return (
    <div className={className.content}>
      {(number || icon) && (
        <div className={className.numberIconContent}>
          {number}
          {icon && (
            <div className={className.iconContainer}>
              <DynamicIcon icon={icon} customClassName="h-full w-full" />
            </div>
          )}
        </div>
      )}
      <h4 className={className.title}>{title}</h4>
      <p className="monochrome:text-white">{description}</p>
    </div>
  );
};

export default ContentStep;
